import { onBeforeUnmount, type Ref } from 'vue'

export type ActionCallback = (key: 'up' | 'down' | 'left' | 'right' | 'escape') => void

export default function useKeyboardBindings(element: Ref<HTMLElement | null>, actionCallback: ActionCallback) {
  let isListening = false

  function handleKeys(event: KeyboardEvent) {
    switch (event.key) {
      case 'Escape':
        event.stopPropagation()
        actionCallback('escape')
        break
      case 'ArrowUp':
        event.stopPropagation()
        actionCallback('up')
        break
      case 'ArrowDown':
        event.stopPropagation()
        actionCallback('down')
        break
      case 'ArrowLeft':
        event.stopPropagation()
        actionCallback('left')
        break
      case 'ArrowRight':
        event.stopPropagation()
        actionCallback('right')
        break
      default:
        break
    }
  }

  const addKeyboardListener = () => {
    if (isListening || !element.value) {
      return
    }

    isListening = true
    element.value.addEventListener('keydown', handleKeys)
  }

  const removeKeyboardListener = () => {
    if (!isListening || !element.value) return

    isListening = false
    element.value?.removeEventListener('keydown', handleKeys)
  }

  onBeforeUnmount(() => {
    removeKeyboardListener()
  })

  return {
    addKeyboardListener,
    removeKeyboardListener,
  }
}
